import { ChangeDetectionStrategy, Component, inject, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Observable, map, startWith, withLatestFrom, switchMap, tap, combineLatest } from 'rxjs';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { UsersStore } from 'src/app/features/users/users-store';
import { ContactDisplayComponent } from '../contact-display/contact-display.component';
import { User } from 'src/app/models/user.model';
import { MiniContactDisplayComponent } from '../mini-contact-display/mini-contact-display.component';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { Recipient } from 'src/app/models/recipients.model';
import { MiniGroupDisplayComponent } from '../mini-group-display/mini-group-display.component';
import { GroupDisplayComponent } from '../group-display/group-display.component';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { toSignal } from '@angular/core/rxjs-interop';
@Component({
    selector: 'que-select-users-input',
    imports: [CommonModule, FormsModule,
        MatFormFieldModule,
        MatInputModule,
        TranslateDirective, TranslatePipe,
        MatAutocompleteModule,
        ContactDisplayComponent,
        GroupDisplayComponent,
        ReactiveFormsModule,
        MiniContactDisplayComponent,
        MiniGroupDisplayComponent,
        OverlayModule
    ],
    templateUrl: './select-users-input.component.html',
    styleUrls: ['./select-users-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectUsersInputComponent {

  @Input() displayInput = true;
  @Input() isInPublish = false;
  @Input() isJustUserInput = false;
  @Input() canDelete = true;
  @Input() isdisabled: boolean = false;
  #usersStore = inject(UsersStore);
  myControl = new FormControl('');
  myControlGroups = new FormControl('');

  users$ = toSignal(combineLatest(([this.#usersStore.usersWithoutChoosen$, this.myControl.valueChanges.pipe(startWith(''))])).pipe(
    map(([users, value]) => users.map(user => { return { ...user, fullName: ` ${user.firstName} ${user.lastName} ` } })
      .filter(x => x.fullName.toLocaleLowerCase().includes(value?.toLocaleLowerCase() ?? '') || x.email.split('@').includes(value ?? '')))));

  groups$ = toSignal(combineLatest(([this.#usersStore.groupsWithoutChoosen$, this.myControlGroups.valueChanges.pipe(startWith(''))])).pipe(
    map(([groups, value]) => groups.map(group => { return group })
      .filter(x => x.name.toLocaleLowerCase().includes(value?.toLocaleLowerCase() ?? '')))));

  loadingGroups$ = toSignal(this.#usersStore.loadingGroup$);
  loadingUsers$ = toSignal(this.#usersStore.loadingUsers$);
  recipients$ = this.#usersStore.recipient$;
  distributionGroup$ = this.#usersStore.groups$.pipe(map(x => x?.map(g => { return { ...g, users: g.users?.map(u => u.user) } as DistributionGroup })));
  usersArr: string[] = [];
  // options: string[] = ['One', 'Two', 'Three', 'One', 'Two', 'Three', 'One', 'Two', 'Three', 'One', 'Two', 'Three'];
  options: string[] = [];
  filteredOptions: Observable<string[]> | undefined;
  filteredUsers: User[] | undefined;
  maxOptionsToShow = 5;

  newGroupsId: number[] = []
  newUsersId: number[] = []

  openSelectUser = false;
  openSelectTeams = false;
  readonly positonArea = [{
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  }] as ConnectedPosition[];


  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }
  onContactSelected(user: User): void {
    // The selected option is available in the event option property
    this.myControl.setValue('');
    this.#usersStore.addRecipient(user);
    this.newUsersId = [...this.newUsersId, user.id]
    this.openSelectUser = false;
  }
  onGroupSelected(group: DistributionGroup): void {
    this.myControlGroups.setValue('');
    this.#usersStore.addGroup(group);
    this.newGroupsId = [...this.newGroupsId, group.id]
    this.openSelectTeams = false;
  }
  isNewGroup(id: number) {
    var x = this.newGroupsId.filter(x => x == id);
    return x.length > 0;
  }
  isNewUser(id: number) {
    var x = this.newUsersId.filter(x => x == id);
    return x.length > 0;
  }

  private updateEnabledControlState(): void {

    if (!this.isdisabled) {
      this.myControl.enable({ emitEvent: false });
      this.myControlGroups.enable({ emitEvent: false });
      return;
    }

    this.myControl.disable({ emitEvent: false });
    this.myControlGroups.disable({ emitEvent: false });

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isdisabled']) {
      this.updateEnabledControlState();
    }
  }
}

